import { Link } from 'react-router-dom';
import type { MediaItem } from '@/types';

interface MovieCardProps {
  item: MediaItem;
  rank?: number;
}

export default function MovieCard({ item, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block bg-background-100 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-500/50 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 影视封面`}
          title={`${item.title} ${item.genres.join(' ')}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-80"></div>
        {typeof rank === 'number' && (
          <span className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-md bg-accent-500 text-background-50 font-heading text-sm font-bold">
            {rank}
          </span>
        )}
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-50/80 backdrop-blur-sm text-accent-400 text-xs font-semibold">
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-foreground-950 text-xs">
          {item.type === 'movie' ? '电影' : '剧集'}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-accent-400 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 line-clamp-1">
          {item.year} · {item.region} · {item.genres.slice(0, 2).join(' / ')}
        </p>
      </div>
    </Link>
  );
}